/* "Espresso & Brass" v2 — richer, deeper, premium contrast.
   Locked direction. Inspired by leather, whisky, brass hardware. */
import PremiumLandingShell from "@/pages/PremiumLandingShell";

const THEME = {
  id: "espresso",
  name: "espresso & brass",
  bg: "#0E0805",       // richer, deeper espresso (almost black with warm soul)
  ink: "#F5E6C2",      // luminous warm cream — strong contrast on laptop
  seal: "#D4A05A",     // richer aged brass — sings against dark espresso
};

export default function LandingEspresso() {
  return <PremiumLandingShell theme={THEME} />;
}
